import styles from './Footer.module.scss'
import {
  URL_SWEET_SCHOOL_PRIVACY,
  URL_SWEET_SCHOOL_TERMS_AND_CONDITIONS
} from '../../../const/consts'
import { TextSeparator } from '../../../components/UI/TextSeparator/TextSeparator'
import { LinkComponent } from '../../../components/UI/LinkComponent/LinkComponent'

export const Footer = () => (
  <div className={styles.FooterContainer}>
    Copyright &copy; 2023 Słodka Szkoła
    <TextSeparator />
    <LinkComponent
      className={styles.Link}
      href={URL_SWEET_SCHOOL_TERMS_AND_CONDITIONS}
    >
      Regulamin
    </LinkComponent>
    <TextSeparator />
    <LinkComponent className={styles.Link} href={URL_SWEET_SCHOOL_PRIVACY}>
      Polityka prywatności
    </LinkComponent>
  </div>
)
